/* @flow */
import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { connectRequest } from 'redux-query';

import { copyProperties } from '../../utils';
import currentUser from '../../redux/current-user';
import users from '../../redux/users';

export default (Component: React.ComponentType<*>) => {
  class CurrentUserProvider extends React.Component<{
    currentUser: Object,
  }> {
    render() {
      return <Component {...this.props} />;
    }
  }

  // Class inheritance uses Object.create and because of __proto__ issues
  // with IE <10 any static properties of the superclass aren't inherited and
  // so need to be manually populated.
  // See http://babeljs.io/docs/advanced/caveats/#classes-10-and-below-
  copyProperties(Component, CurrentUserProvider);

  const mapStateToProps = state => {
    let currentUserId = currentUser.selectors.getCurrentUserId(state);
    return {
      currentUserId,
      currentUser: users.selectors.getUserById(state, currentUserId),
    };
  };

  const mapPropsToConfig = props => {
    if (props.currentUserId) {
      return users.queries.fetchUser(props.currentUserId);
    } else {
      return null;
    }
  };

  return compose(
    connect(mapStateToProps),
    connectRequest(mapPropsToConfig)
  )(CurrentUserProvider);
};



// WEBPACK FOOTER //
// ./src/ui/components/withCurrentUser.js